import React from "react";

import { TrailingNode } from "./components";

export function AgreementSection() {
  return (
    <div data-test="agreement-section">
      By clicking &quot;Sign up&quot; you agree to Hubly&apos;s{" "}
      {[
        {
          link: "https://www.myhubly.com/subscription-services-agreement",
          name: "Subscription Service Agreement",
        },
        {
          link: "https://www.myhubly.com/privacy-policy",
          name: "Privacy Policy",
        },
      ].map(({ link, name }, n, policies) => {
        return (
          <TrailingNode key={name} node=" and " show={n + 1 < policies.length}>
            <a target="_blank" rel="noopener noreferrer" href={link}>
              {name}
            </a>
          </TrailingNode>
        );
      })}
    </div>
  );
}

export default AgreementSection;
